"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs_1 = __importDefault(require("qs"));
var axios_1 = __importDefault(require("axios"));
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var browser_1 = require("@sentry/browser");
var abstract_container_store_1 = require("@hikakaku/shared/stores/estimate_form/abstract_container_store");
var hidden_form_input_list_store_1 = __importStar(require("@hikakaku/shared/stores/estimate_form/common/hidden_form_input_list_store"));
var page_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/page_store"));
var estimate_form_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/estimate_form"));
var form_header_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/form_header_store"));
var navigation_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/navigation_store"));
var form_inner_card_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/form_inner_card_store"));
var input_card_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input_card_store"));
var input_props_builder_1 = require("@hikakaku/shared/stores/estimate_form/ieul_estimate/input_props_builder");
var alert_store_1 = __importStar(require("@hikakaku/shared/stores/estimate_form/common/alert_store"));
var form_footer_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/form_footer_store"));
var submit_page_footer_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/submit_page_footer_store"));
var dialog_store_1 = __importDefault(require("hikakaku/javascripts/stores/dialog_store"));
var sms_verification_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/sms_verification_store"));
var FORM_TITLE = '不動産査定フォーム';
var FORM_DESCRIPTION = '入力された情報が、お客様の許可なしに一般に公開されることは一切ありません。';
var NAVIGATION_ITEMS = [
    ['査定不動産', '情報入力'],
    ['お客様', '情報入力'],
    ['無料査定', 'スタート']
];
var FETCH_COMPANY_PROPERTY_INPUT_KEYS = [
    'property_street',
    'property_status',
    'property_user_relation',
    'property_exclusive_area',
    'property_exclusive_area_unit',
    'property_land_area',
    'property_land_area_unit',
    'property_building_area',
    'property_building_area_unit',
    'property_floor_area',
    'property_floor_area_unit',
    'property_room_plan',
    'property_constructed_year'
];
var FETCH_COMPANY_USER_INPUT_KEYS = [
    'user_motivation'
];
var VALIDATE_PROPERTY_INPUT_KEYS = [
    'property_street',
    'property_status',
    'property_user_relation',
    'property_exclusive_area',
    'property_exclusive_area_unit',
    'property_land_area',
    'property_land_area_unit',
    'property_building_area',
    'property_building_area_unit',
    'property_floor_area',
    'property_floor_area_unit',
    'property_room_plan',
    'property_constructed_year',
    'property_address',
    'resident',
    'property_building',
    'property_condominium',
    'property_constructed_year',
    'property_room'
];
var VALIDATE_USER_INPUT_KEYS = [
    'user_motivation',
    'user_age',
    'user_town',
    'user_address',
    'user_assessment_type',
    'user_email',
    'user_tel'
];
var VALIDATE_ESTIMATE_STAT_INPUT_KEYS = [
    'user_replacement',
    'user_desired_contact_time_start',
    'user_desired_contact_time_end',
    'company',
    'user_demand',
    'user_desired_date',
    'user_desired_contact_day',
    'user_comment'
];
var buildApiParam = function (keys, stores) { return stores
    .map(function (store) { return ({ key: store.rawName, value: store.value }); })
    .filter(function (_a) {
    var key = _a.key;
    return keys.includes(key);
})
    // observableArray が qs.stringify に対応してないのでtoJSで通常の配列に変換してます
    .reduce(function (acc, _a) {
    var _b;
    var key = _a.key, value = _a.value;
    return (__assign(__assign({}, acc), (_b = {}, _b[key] = (0, mobx_1.toJS)(value), _b)));
}, {}); };
var ContainerStore = /** @class */ (function () {
    function ContainerStore(props) {
        var _this = this;
        this.updateSubmitButtonsDisabled = function (disabled) {
            if (_this.submitPageFooterStore) {
                _this.submitPageFooterStore.isSubmitButtonEnabled = !disabled;
            }
        };
        this.component = estimate_form_1.default;
        this.postUrl = '/ieul_estimate/entries/';
        this.formRef = react_1.default.createRef();
        this.currentPage = 0;
        this.isLoading = false;
        this.isSending = false;
        this.isModalOpen = false;
        this.alertStore = new alert_store_1.default({});
        this.handleClickPropertyPageNextButton = function () {
            if (_this.propertyInputCardStore.isInputAllRequireValues) {
                _this.handleClickNextPageButton();
            }
            else {
                _this.alertStore.alertText = abstract_container_store_1.ALERT_MESSAGE;
            }
        };
        this.handleClickUserPageNextButton = function () {
            if (_this.userInputCardStore.isInputAllRequireValues) {
                _this.fetchCompanyOptions().then(function () { _this.handleClickNextPageButton(); });
            }
            else {
                _this.alertStore.alertText = abstract_container_store_1.ALERT_MESSAGE;
            }
        };
        this.handleClickSubmitButton = function (event) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        if (!!this.estimateStatInputCardStore.isInputAllRequireValues) return [3 /*break*/, 1];
                        this.alertStore.alertText = abstract_container_store_1.ALERT_MESSAGE;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.validate()];
                    case 2:
                        if (_a.sent()) {
                            this.formRef.current && this.formRef.current.submit();
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.handleClickNextPageButton = function () {
            _this.currentPage = Math.min(_this.currentPage + 1, _this.pageStores.length - 1);
        };
        this.handleClickPrevPageButton = function () {
            _this.currentPage = Math.max(_this.currentPage - 1, 0);
        };
        this.handleModalClose = function () {
            _this.isModalOpen = false;
        };
        this.showModal = function (onClickButton) {
            onClickButton && (_this.handleModalButtonClick = onClickButton);
            _this.isModalOpen = true;
        };
        this.removeBeforeUnloadEvent = function () {
            // No-op for ieul_estimate
        };
        this.handleChangePage = function () {
            _this.pageStores.forEach(function (store, idx) {
                store.isActive = _this.currentPage === idx;
            });
            _this.formRef.current && _this.formRef.current.scrollIntoView(true);
        };
        this.handleChangePrefId = function (id) { return __awaiter(_this, void 0, Promise, function () {
            var data, options, cityId_1, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.get("/api/ieul/prefectures/".concat(id, "/cities"))];
                    case 2:
                        data = (_a.sent()).data;
                        options = data.reduce(function (acc, v) { return __spreadArray(__spreadArray([], acc, true), v.cities.map(function (city) { return ({ label: city.name, value: String(city.id) }); }), true); }, []);
                        this.propertyInputCardStore.replaceInputStore((0, input_props_builder_1.cityIdInput)(options));
                        this.propertyInputCardStore.replaceInputStore((0, input_props_builder_1.townIdInput)());
                        this.propertyInputCardStore.replaceInputStore((0, input_props_builder_1.propertyStreetInput)());
                        cityId_1 = this.propertyInputCardStore.findInputStoreByRawName('city_id');
                        this.cityIdDisposer && this.cityIdDisposer();
                        this.townIdDisposer && this.townIdDisposer();
                        this.cityIdDisposer = (0, mobx_1.reaction)(function () { return cityId_1 === null || cityId_1 === void 0 ? void 0 : cityId_1.value; }, this.handleChangeCityId);
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        window.DialogStore.showErrorDialog();
                        (0, browser_1.captureException)(err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.handleChangeCityId = function (id) { return __awaiter(_this, void 0, Promise, function () {
            var data, options, townId_1, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.get("/api/ieul/cities/".concat(id, "/towns"))];
                    case 2:
                        data = (_a.sent()).data;
                        options = data.reduce(function (acc, v) { return __spreadArray(__spreadArray([], acc, true), v.towns.map(function (town) { return ({ label: town.name, value: String(town.id) }); }), true); }, []);
                        this.propertyInputCardStore.replaceInputStore((0, input_props_builder_1.townIdInput)(options));
                        this.propertyInputCardStore.replaceInputStore((0, input_props_builder_1.propertyStreetInput)());
                        townId_1 = this.propertyInputCardStore.findInputStoreByRawName('town_id');
                        this.townIdDisposer && this.townIdDisposer();
                        this.townIdDisposer = (0, mobx_1.reaction)(function () { return townId_1 === null || townId_1 === void 0 ? void 0 : townId_1.value; }, this.handleChangeTownId);
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        window.DialogStore.showErrorDialog();
                        (0, browser_1.captureException)(err_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.handleChangeTownId = function (id) { return __awaiter(_this, void 0, Promise, function () {
            var data, options, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.get("/api/ieul/towns/".concat(id, "/streets"))];
                    case 2:
                        data = (_a.sent()).data;
                        options = data.map(function (street) { return ({ label: street.name, value: String(street.id) }); });
                        this.propertyInputCardStore.replaceInputStore((0, input_props_builder_1.propertyStreetInput)(options));
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        window.DialogStore.showErrorDialog();
                        (0, browser_1.captureException)(err_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.handleChangeUserPref = function (id) { return __awaiter(_this, void 0, Promise, function () {
            var data, options, userCity_1, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get("/api/ieul/prefectures/".concat(id, "/cities"))];
                    case 1:
                        data = (_a.sent()).data;
                        options = data.reduce(function (acc, v) { return __spreadArray(__spreadArray([], acc, true), v.cities.map(function (city) { return ({ label: city.name, value: String(city.id) }); }), true); }, []);
                        this.userInputCardStore.replaceInputStore((0, input_props_builder_1.userCityInput)(options));
                        this.userInputCardStore.replaceInputStore((0, input_props_builder_1.userTownInput)());
                        userCity_1 = this.userInputCardStore.findInputStoreByRawName('user_city');
                        this.userCityDisposer && this.userCityDisposer();
                        (0, mobx_1.reaction)(function () { return userCity_1 === null || userCity_1 === void 0 ? void 0 : userCity_1.value; }, this.handleChangeUserCity);
                        return [3 /*break*/, 3];
                    case 2:
                        err_4 = _a.sent();
                        window.DialogStore.showErrorDialog();
                        (0, browser_1.captureException)(err_4);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.handleChangeUserCity = function (id) { return __awaiter(_this, void 0, Promise, function () {
            var res, options, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get("/api/ieul/cities/".concat(id, "/towns"))];
                    case 1:
                        res = _a.sent();
                        options = res.data.reduce(function (acc, v) { return __spreadArray(__spreadArray([], acc, true), v.towns.map(function (town) { return ({ label: town.name, value: town.id }); }), true); }, []);
                        this.userInputCardStore.replaceInputStore((0, input_props_builder_1.userTownInput)(options));
                        return [3 /*break*/, 3];
                    case 2:
                        err_5 = _a.sent();
                        window.DialogStore.showErrorDialog();
                        (0, browser_1.captureException)(err_5);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.fetchCompanyOptions = function () { return __awaiter(_this, void 0, Promise, function () {
            var params, data, options, err_6, data;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        params = __assign(__assign({ url_param: this.urlParam, property_type: this.propertyType }, buildApiParam(FETCH_COMPANY_PROPERTY_INPUT_KEYS, this.propertyInputCardStore.inputListStore.inputStores)), buildApiParam(FETCH_COMPANY_USER_INPUT_KEYS, this.userInputCardStore.inputListStore.inputStores));
                        return [4 /*yield*/, axios_1.default.get("/api/ieul/companies", { params: params })];
                    case 1:
                        data = (_b.sent()).data;
                        options = data.map(function (company) { return ({ label: company.name, value: String(company.id) }); });
                        this.estimateStatInputCardStore.replaceInputStore((0, input_props_builder_1.companyInput)(options));
                        return [3 /*break*/, 3];
                    case 2:
                        err_6 = _b.sent();
                        data = (_a = err_6.response) === null || _a === void 0 ? void 0 : _a.data;
                        if (data) {
                            window.DialogStore.showDialog({
                                title: 'ご入力された内容に不備がありました。',
                                description: Object.values(JSON.parse(data)).join('<br>'),
                                btnList: [{
                                        title: '閉じる',
                                        callback: window.DialogStore.hideDialog,
                                        customClass: 'btn-blue'
                                    }],
                                show_time: -1
                            });
                        }
                        else {
                            window.DialogStore.showErrorDialog();
                        }
                        (0, browser_1.captureException)(err_6);
                        throw err_6;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.validate = function () { return __awaiter(_this, void 0, Promise, function () {
            var params, err_7, data;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        params = {
                            ieul_estimate_entry: __assign(__assign(__assign({ rtsp: this.rtsp, url_param: this.urlParam, property_type: this.propertyType, user_name: this.hiddenFieldInputListStore.getValue('ieul_estimate_entry[user_name]'), user_name_kana: this.hiddenFieldInputListStore.getValue('ieul_estimate_entry[user_name_kana]') }, buildApiParam(VALIDATE_PROPERTY_INPUT_KEYS, this.propertyInputCardStore.inputListStore.inputStores)), buildApiParam(VALIDATE_USER_INPUT_KEYS, this.userInputCardStore.inputListStore.inputStores)), buildApiParam(VALIDATE_ESTIMATE_STAT_INPUT_KEYS, this.estimateStatInputCardStore.inputListStore.inputStores))
                        };
                        return [4 /*yield*/, axios_1.default.get("/api/ieul_estimate/prepare", {
                                params: params,
                                paramsSerializer: function (params) { return qs_1.default.stringify(params, { arrayFormat: 'brackets' }); }
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, true];
                    case 2:
                        err_7 = _b.sent();
                        data = (_a = err_7.response) === null || _a === void 0 ? void 0 : _a.data;
                        if (data && Array.isArray(data)) {
                            dialog_store_1.default.showDialog({
                                title: "ご入力された内容に不備がありました。",
                                description: data.join('<br>'),
                                btnList: [
                                    {
                                        title: "閉じる",
                                        callback: function () {
                                            dialog_store_1.default.hideDialog();
                                        },
                                        customClass: "btn-blue"
                                    },
                                ],
                                show_time: -1
                            });
                        }
                        else {
                            window.DialogStore.showErrorDialog();
                        }
                        (0, browser_1.captureException)(err_7);
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.rtsp = props.rtsp;
        this.urlParam = props.urlParam;
        this.propertyType = props.propertyType;
        this.smsVerificationStore = new sms_verification_store_1.default({});
        var headerStore = new form_header_store_1.default({ title: FORM_TITLE, description: FORM_DESCRIPTION });
        this.propertyInputCardStore = new input_card_store_1.default({
            title: '査定不動産情報の入力',
            inputProps: (0, input_props_builder_1.buildPropertyFormProps)(props)
        });
        this.userInputCardStore = new input_card_store_1.default({
            title: 'お客様情報の入力',
            inputProps: (0, input_props_builder_1.buildUserFormInputProps)(props)
        });
        this.estimateStatInputCardStore = new input_card_store_1.default({
            title: '無料査定スタート',
            inputProps: (0, input_props_builder_1.buildEstimateStatInputProps)(props)
        });
        this.hiddenFieldInputListStore = new hidden_form_input_list_store_1.default({
            hiddenFields: [
                { name: 'authenticity_token', value: props.authenticityToken },
                { name: 'ieul_estimate_entry[rtsp]', value: props.rtsp },
                { name: 'ieul_estimate_entry[property_type]', value: String(props.propertyType) },
                { name: 'ieul_estimate_entry[url_param]', value: props.urlParam },
            ]
        });
        this.fixedComponentStores = [
            this.hiddenFieldInputListStore
        ];
        this.pageStores = [
            new page_store_1.default({
                elementStores: [
                    headerStore,
                    this.alertStore,
                    new navigation_store_1.default({ navigationItems: NAVIGATION_ITEMS, step: 1 }),
                    new form_inner_card_store_1.default({
                        elementStores: [
                            this.propertyInputCardStore,
                            this.alertStore,
                            new form_footer_store_1.default({
                                showsNextButton: true,
                                onClickNextButton: this.handleClickPropertyPageNextButton
                            })
                        ]
                    })
                ]
            }),
            new page_store_1.default({
                elementStores: [
                    headerStore,
                    new navigation_store_1.default({ navigationItems: NAVIGATION_ITEMS, step: 2 }),
                    new form_inner_card_store_1.default({
                        elementStores: [
                            this.userInputCardStore,
                            this.alertStore,
                            new form_footer_store_1.default({
                                description: 'あと少しで入力完了！',
                                showsNextButton: true,
                                onClickNextButton: this.handleClickUserPageNextButton,
                                onClickPrevButton: this.handleClickPrevPageButton
                            })
                        ]
                    })
                ]
            }),
            new page_store_1.default({
                elementStores: [
                    headerStore,
                    this.alertStore,
                    new navigation_store_1.default({ navigationItems: NAVIGATION_ITEMS, step: 3 }),
                    new form_inner_card_store_1.default({
                        elementStores: [
                            this.estimateStatInputCardStore,
                            this.alertStore,
                            new submit_page_footer_store_1.default({
                                submitButtonText: '査定申し込み',
                                onClickSubmitButton: this.handleClickSubmitButton,
                                onClickPrevButton: this.handleClickPrevPageButton,
                            })
                        ]
                    })
                ]
            })
        ];
        // Store reference to submit page footer store for disabling
        var lastPage = this.pageStores[this.pageStores.length - 1];
        if (lastPage) {
            for (var _i = 0, _a = lastPage.elementStores; _i < _a.length; _i++) {
                var elementStore = _a[_i];
                if (elementStore instanceof form_inner_card_store_1.default) {
                    var submitStore = elementStore.elementStores.find(function (store) { return store instanceof submit_page_footer_store_1.default; });
                    if (submitStore) {
                        this.submitPageFooterStore = submitStore;
                        break;
                    }
                }
            }
        }
        (0, mobx_1.reaction)(function () { return _this.currentPage; }, this.handleChangePage, { fireImmediately: true });
        (0, mobx_1.reaction)(function () { return _this.currentPage; }, this.alertStore.clear);
        var prefId = this.propertyInputCardStore.findInputStoreByRawName('pref_id');
        var userCardInputs = this.userInputCardStore.inputListStore.inputStores
            .reduce(function (acc, store) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[store.rawName] = store, _a)));
        }, {});
        (0, mobx_1.reaction)(function () { return prefId === null || prefId === void 0 ? void 0 : prefId.value; }, this.handleChangePrefId);
        (0, mobx_1.reaction)(function () { var _a; return (_a = userCardInputs['user_pref']) === null || _a === void 0 ? void 0 : _a.value; }, this.handleChangeUserPref);
        (0, mobx_1.reaction)(function () { var _a, _b; return ({ last: (_a = userCardInputs['user_name_last']) === null || _a === void 0 ? void 0 : _a.value, first: (_b = userCardInputs['user_name_first']) === null || _b === void 0 ? void 0 : _b.value }); }, function (_a) {
            var last = _a.last, first = _a.first;
            return last && first && _this.hiddenFieldInputListStore.replaceHiddenField({
                name: 'ieul_estimate_entry[user_name]', value: "".concat(last, " ").concat(first)
            });
        });
        (0, mobx_1.reaction)(function () { var _a, _b; return ({ last: (_a = userCardInputs['user_name_kana_last']) === null || _a === void 0 ? void 0 : _a.value, first: (_b = userCardInputs['user_name_kana_first']) === null || _b === void 0 ? void 0 : _b.value }); }, function (_a) {
            var last = _a.last, first = _a.first;
            return last && first && _this.hiddenFieldInputListStore.replaceHiddenField({
                name: 'ieul_estimate_entry[user_name_kana]', value: "".concat(last, " ").concat(first)
            });
        });
    }
    var _a, _b, _c, _d, _e;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "formRef", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "currentPage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "isLoading", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "isSending", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "isModalOpen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof hidden_form_input_list_store_1.IHiddenFormInputListStore !== "undefined" && hidden_form_input_list_store_1.IHiddenFormInputListStore) === "function" ? _a : Object)
    ], ContainerStore.prototype, "hiddenFieldInputListStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ContainerStore.prototype, "fixedComponentStores", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ContainerStore.prototype, "pageStores", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_b = typeof alert_store_1.IAlertStore !== "undefined" && alert_store_1.IAlertStore) === "function" ? _b : Object)
    ], ContainerStore.prototype, "alertStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_c = typeof mobx_1.IReactionDisposer !== "undefined" && mobx_1.IReactionDisposer) === "function" ? _c : Object)
    ], ContainerStore.prototype, "cityIdDisposer", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_d = typeof mobx_1.IReactionDisposer !== "undefined" && mobx_1.IReactionDisposer) === "function" ? _d : Object)
    ], ContainerStore.prototype, "townIdDisposer", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_e = typeof mobx_1.IReactionDisposer !== "undefined" && mobx_1.IReactionDisposer) === "function" ? _e : Object)
    ], ContainerStore.prototype, "userCityDisposer", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "handleClickPropertyPageNextButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "handleClickUserPageNextButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "handleClickSubmitButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "handleClickNextPageButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "handleClickPrevPageButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "handleModalClose", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "showModal", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "handleChangePage", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "handleChangePrefId", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "handleChangeCityId", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "handleChangeTownId", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "handleChangeUserPref", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "handleChangeUserCity", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContainerStore.prototype, "fetchCompanyOptions", void 0);
    return ContainerStore;
}());
exports.default = ContainerStore;
